"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widthSizesSchema = exports.heightSizesSchema = void 0;
exports.heightSizesSchema = {
    1: 'h-1',
    2: 'h-2',
    3: 'h-3',
    4: 'h-4',
    5: 'h-5',
    6: 'h-6',
    7: 'h-7',
    8: 'h-8',
    9: 'h-9',
    10: 'h-10',
    11: 'h-11',
    12: 'h-12',
    13: 'h-13',
    14: 'h-14',
    15: 'h-15',
    16: 'h-16',
    17: 'h-17',
    18: 'h-18',
    19: 'h-19',
    20: 'h-20',
    24: 'h-24',
    28: 'h-28',
    32: 'h-32',
    36: 'h-36',
    40: 'h-40',
    44: 'h-44',
    48: 'h-48',
    52: 'h-52',
    56: 'h-56',
    60: 'h-60',
    64: 'h-64',
    72: 'h-72',
    80: 'h-80',
    96: 'h-96',
    short: 'h-1/3',
    medium: 'h-1/2',
    long: 'h-2/3',
    full: 'h-full',
    auto: 'h-auto',
};
exports.widthSizesSchema = {
    1: 'w-1',
    2: 'w-2',
    3: 'w-3',
    4: 'w-4',
    5: 'w-5',
    6: 'w-6',
    7: 'w-7',
    8: 'w-8',
    9: 'w-9',
    10: 'w-10',
    11: 'w-11',
    12: 'w-12',
    13: 'w-13',
    14: 'w-14',
    15: 'w-15',
    16: 'w-16',
    17: 'w-17',
    18: 'w-18',
    19: 'w-19',
    20: 'w-20',
    24: 'w-24',
    28: 'w-28',
    32: 'w-32',
    36: 'w-36',
    40: 'w-40',
    44: 'w-44',
    48: 'w-48',
    52: 'w-52',
    56: 'w-56',
    60: 'w-60',
    64: 'w-64',
    72: 'w-72',
    80: 'w-80',
    96: 'w-96',
    short: 'w-1/3',
    medium: 'w-1/2',
    long: 'w-2/3',
    full: 'w-full',
    auto: 'w-auto',
};
//# sourceMappingURL=schemas.js.map